import { useGameStore } from '../game/store.js';
import { Button } from './button.jsx';

/**
 * Shown mid-round whenever the cursor is released. Escape is the only way to get
 * the pointer back, so without this the player is stuck in a game that has
 * stopped responding with no visible way out.
 */
export const PauseMenu = ({
  onResume,
  onSettings,
  onLeave,
}: {
  onResume: () => void;
  onSettings: () => void;
  onLeave: () => void;
}) => {
  const mapName = useGameStore((state) => state.mapName);
  const roundWins = useGameStore((state) => state.roundWins);
  const inHub = useGameStore((state) => state.inHub);

  return (
    <div className="fixed inset-0 z-20 grid place-items-center bg-surface-900/70 backdrop-blur-sm">
      <div className="w-[min(360px,90vw)] animate-rise rounded-xl border border-white/10 bg-surface-800/95 p-7 text-center">
        <div className="text-[11px] uppercase tracking-[0.25em] text-ink-muted">
          {mapName}
        </div>
        <h2 className="mt-1 text-2xl font-extrabold tracking-tight">Paused</h2>

        {!inHub && (
          <div className="mt-4 flex items-center justify-center gap-6 tabular">
            <span className="text-2xl font-bold text-team-blue">{roundWins[0]}</span>
            <span className="text-sm text-ink-muted">—</span>
            <span className="text-2xl font-bold text-team-red">{roundWins[1]}</span>
          </div>
        )}

        <Button size="lg" className="mt-6" onClick={onResume}>
          Resume
        </Button>
        <Button size="lg" variant="ghost" className="mt-2.5" onClick={onSettings}>
          Settings
        </Button>
        <Button size="lg" variant="ghost" className="mt-2.5" onClick={onLeave}>
          {inHub ? 'Exit to menu' : 'Return to lobby'}
        </Button>

        {!inHub && (
          <p className="mt-4 text-xs text-ink-muted">
            The round keeps going without you while this is open.
          </p>
        )}
      </div>
    </div>
  );
};
